import { createReducer } from "reduxsauce";
import _ from "lodash";
import ReducerRegister from "../../ReducerRegister";
import { ActionTypes } from "../../actionTypes/screens/plain/PromotionDetailsActionTypes";
import DetailsService from "../../../services/plain/PromotionDetailsService"
import AsyncActionReducers from "../../AsyncActionReducers";

import UIDs from "../../../UIDs";

const uid = UIDs.screens.plain.promotiondetails;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: (vo) => {
        return (dispatch) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, vo });

            DetailsService.loadScreenView(
                vo,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    updateValue: (newValue) => ({
        type: ActionTypes.UPDATE_VALUE,
        newValue
    }),
};

/* ------------- Initial State ------------- */
const INITIAL_STATE = {
    promotionInfo: null,
    isTeacher: false,
    isExpire: false,
    banners: {
        th: [],
        en: [],
        ko: [],
        zh: [],
    },
};

/* ------------- Reducers ------------- */
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    return { ...state, promotionInfo: data.promotionInfo.promotionInfo, isTeacher: data.promotionInfo.isTeacher, banners: data.promotionInfo.promotionInfo.banners};
};

const updateValueReducer = (state, { newValue }) => {
    return { ...state, ...newValue, };
};

/* ------------- Hookup Reducers To Types ------------- */

const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.UPDATE_VALUE]: updateValueReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
